import { useTheme } from "../../../../../theme";

export default function Toggle({ on, onToggle, color }) {
  const t = useTheme();
  return (
    <button onClick={onToggle} style={{
      width: 30, height: 16, borderRadius: 8, padding: 2,
      background: on ? `${color}33` : t.surface,
      border: `1px solid ${on ? `${color}55` : t.borderStrong}`,
      cursor: "pointer", transition: "all 0.2s ease", position: "relative",
      flexShrink: 0,
    }}>
      <div style={{
        width: 10, height: 10, borderRadius: "50%",
        background: on ? color : t.textFaint,
        transition: "all 0.2s ease",
        transform: on ? "translateX(12px)" : "translateX(0)",
      }} />
    </button>
  );
}
